class CartPopupRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-popup').removeProductFromCart(this.dataset.index);
    });
  }
}

customElements.define('cart-popup-remove-button', CartPopupRemoveButton);

class CartPopup extends HTMLElement {
  constructor() {
    super();
    this.container = document.getElementById('card-popup-container');
    this.blurOverlay = document.getElementById('card-popup-overlay');
    this.closeButton = document.getElementById('card-popup-close');
    this.openButton = document.getElementById('cart-icon-bubble-desktop');
    this.openButtonMobile = document.getElementById('cart-icon-bubble-mobile');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.confirmationCheckbox = document.querySelector('#cart-popup-backorder-confirmation #confirmation');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.container.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.openButton.addEventListener('click', this.open.bind(this));
    this.openButtonMobile.addEventListener('click', this.open.bind(this));

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.timeout;
    
  }


  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateDom (body, line, name, message) {
    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const isCartEmpty = parsedState.item_count === 0;
          this.classList.toggle('is-empty', isCartEmpty);

          this.getSectionsToRender().forEach((section => {
            if (section.ids && Array.isArray(section.ids)) {
              section.ids.forEach((id) => {
                const sectionToReplace = document.getElementById(id);
                sectionToReplace.classList.add("updated");
                sectionToReplace.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              });
            } else {
              const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

              elementToReplace.innerHTML =
                  this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          if (!isCartEmpty) this.updateLiveRegions(line, parsedState.item_count, message);
          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading();
          if (isCartEmpty) this.close();
          ;
        }).catch((e) => {
          console.error(e);
          const overlay = this.querySelector('.loading-overlay');
          if (overlay) overlay.classList.add('hidden');
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
          this.close();
    }).finally(() =>{
      const cartChangeEvent = new CustomEvent('tk:cart-updated');
      document.dispatchEvent(cartChangeEvent);
          
      // Extend - Dispatch event 
      window.setTimeout(function() {
        window.dispatchEvent(new Event('refreshAjaxSideCart'))
      }, 500)
      // Extend - End code
    });
  }

  removeProductFromCart(line) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity: 0,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    const elementToReplace = document.getElementById(`CartItem-${line}`);

    if (elementToReplace) elementToReplace.remove();
    this.updateDom(body, line);
  }

  updateQuantity(line, quantity, name) {
    if(line) {
      this.enableLoading(line);

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      const message = `Quantity updated to ${quantity}`
      this.updateDom(body, line, name, message);
    }
  }

  updateLiveRegions(line, itemCount, message) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
          .querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
      );
    } else {
      if (message) {
        setTimeout(() => {
          document.getElementById('cart-live-region-text').innerText = message
        },300)
      }
    }
    // refine this for live region update
    // else {
    //   document.getElementById('cart-live-region-text').innerText = `Item count is now ${itemCount}`
    // }

    this.currentItemCount = itemCount;
  }

  enableLoading(line) {
    const submitButton = this.querySelector('[name="checkout"]');
    document.getElementById('cart-popup-products').classList.add('cart__items--disabled');
    this.querySelector(`#CartItem-${line} .loading-overlay`).classList.remove('hidden');
    if (submitButton) {
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      submitButton.querySelector(".loading-overlay__spinner").classList.remove('hidden')
      submitButton.querySelector(".loading-overlay").classList.remove('hidden')
      clearTimeout(this.timeout);
    }
    document.activeElement.blur();
  }

  disableLoading() {
    const submitButton = this.querySelector('[name="checkout"]');
    document.getElementById('cart-popup-products').classList.remove('cart__items--disabled');
    if (submitButton) {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      submitButton.querySelector(".loading-overlay__spinner").classList.add('hidden')
      submitButton.querySelector(".loading-overlay").classList.add('hidden')
      submitButton.classList.add('clicked');
      this.timeout = setTimeout(() => {
        submitButton.classList.remove('clicked')
      }, 3000);
    }
  }

  open() {
    this.container.classList.add("open");
    this.container.classList.remove("transition");
    this.blurOverlay.classList.add("open");
    $(this.blurOverlay).css({ display: "block", opacity: 0 }).animate({ opacity: 1 });
    document.body.classList.toggle("no-scroll", true);

    trapFocus(this.container);
    this.blurOverlay.addEventListener('click', this.onBodyClick);

    // Extend - Dispatch event
    window.setTimeout(function() {
      window.dispatchEvent(new Event('refreshAjaxSideCart'))
    }, 500)
    // Extend - End code
  }

  close() {
    this.container.classList.remove('open');
    this.container.classList.add("transition");
    this.blurOverlay.classList.remove("open");
    document.body.classList.toggle("no-scroll", false);
    $(this.blurOverlay).animate({
      opacity: 0,
      done: function () {
        $(this).css({ display: "none" });
      },
    });

    this.blurOverlay.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, shouldOpenCart) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        if (section.ids && Array.isArray(section.ids)) {
          section.ids.forEach((id) => {
            const sectionToReplace = document.getElementById(id);
            sectionToReplace.classList.add("updated");
            sectionToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          });
        } else {
          const sectionToReplace = document.getElementById(section.id);
          sectionToReplace.classList.add("updated");
          sectionToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }
      }));
      
      if (shouldOpenCart) {
        this.open();
      }
  }

  renderJSONContents(jsonResponse) {
    this.getSectionsToRender().forEach((section => {
      if (section.ids && Array.isArray(section.ids)) {
        section.ids.forEach((id) => {
          document.getElementById(id).innerHTML =
              this.getSectionInnerHTML(jsonResponse[section.section], section.selector);
        });
      } else {
        document.getElementById(section.id).innerHTML =
            this.getSectionInnerHTML(jsonResponse[section.section], section.selector);
      }
    }));
  }

  renderUpdatedJSONContents(jsonResponse) {
    this.getSectionsToRender().forEach((section => {
      if (section.ids && Array.isArray(section.ids)) {
        section.ids.forEach((id) => {
          const sectionToReplace = document.getElementById(id);
          sectionToReplace.classList.add("updated");
          sectionToReplace.innerHTML = this.getSectionInnerHTML(jsonResponse[section.section], section.selector);
        });
      } else {
        const sectionToReplace = document.getElementById(section.id);
        sectionToReplace.classList.add("updated");
        sectionToReplace.innerHTML = this.getSectionInnerHTML(jsonResponse[section.section], section.selector);
      }
    }));
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-popup-products',
        section: "cart-popup-products",
        selector: "#cart-popup-products"
      },
      {
        id: 'cart-popup-backorder-confirmation',
        section: 'cart-popup-backorder-confirmation',
        selector: "#cart-popup-backorder-confirmation"
      },
      {
        ids: ['cart-icon-bubble-desktop', 'cart-icon-bubble-mobile'],
        section: 'cart-icon-bubble',
      },
      {
        id: 'cart-popup-total',
        section: 'cart-popup-total',
        selector: "#cart-popup-total"
      },
      {
        id: 'cart-popup-checkout',
        section: 'cart-popup-checkout',
        selector: "#cart-popup-checkout"
      },
    ];

    // put this in because for some reason the sections API failed with related section locally
    // if (!window.location.href.includes('127.0.0.1')) {
    //   sections.push({
    //     id: 'cart-popup-related-products',
    //     section: 'cart-popup-related-products',
    //     selector: "#cart-popup-related-products"
    //   })
    // }

    return sections
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(e) {
    const target = e.target;
    if (target !== this.container) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-popup', CartPopup);
